package com.karawek.core.ui.components

import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.ui.Alignment
import androidx.compose.ui.unit.dp
import com.karawek.core.ui.haptics.HapticType
import com.karawek.core.ui.haptics.LocalHapticsEnabled
import com.karawek.core.ui.haptics.performHapticIfEnabled
import com.karawek.core.ui.theme.CoreShapes
import com.karawek.core.ui.theme.CoreSpacing

@Composable
fun CorePrimaryButton(
    text: String,
    enabled: Boolean = true,
    leadingIcon: ImageVector? = null,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val hapticsEnabled by rememberUpdatedState(LocalHapticsEnabled.current)

    Button(
        enabled = enabled,
        onClick = {
            performHapticIfEnabled(hapticsEnabled, HapticType.Tap)
            onClick()
        },
        modifier = modifier,
        shape = CoreShapes.lg,
        colors = ButtonDefaults.buttonColors(
            containerColor = MaterialTheme.colorScheme.primary,
            contentColor = MaterialTheme.colorScheme.onPrimary,
            disabledContainerColor = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.12f),
            disabledContentColor = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.38f),
        )
    ) {
        Row(
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            leadingIcon?.let {
                Icon(
                    imageVector = it,
                    contentDescription = null,
                    modifier = Modifier.size(20.dp),
                )
                Spacer(modifier = Modifier.width(CoreSpacing.sm))
            }
            Text(text)
        }
    }
}
